export const state = {
	operations: [],
	contracts: []
}



// WEBPACK FOOTER //
// ./src/common/store/Transactions/state.js